import React, { useEffect, useState } from "react";
import {
  currentAffiliate,
  updateAffiliate,
} from "../../../../stores/actions/affiliate.actions.types";
import * as Yup from "yup";
import MetaHead from "../../../Common/Metahead";
import { Form, Formik } from "formik";
import { TextInput } from "../../../UI/FormField";
import { BiLoaderAlt } from "react-icons/bi";
import { useTranslation } from "react-i18next";
import { connect, useSelector } from "react-redux";
import { successMessage } from "../../../../utilities/notification";

const MyLinkPage = ({ currentAffiliate, updateAffiliate }) => {
  const { t } = useTranslation();
  const [affiliate, setAffiliate] = useState(null);
  const [reload, setReload] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [updateloading, setUpdateloading] = useState(false);
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(false);
  const affiliates = useSelector((state) => state.affiliate.affiliate);

  const [secondsLeft, setSecondsLeft] = useState(0);

  useEffect(() => {
    let interval;
    if (copied && secondsLeft > 0) {
      interval = setInterval(() => {
        setSecondsLeft((prev) => {
          if (prev <= 1) {
            setCopied(false);
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [copied, secondsLeft]);

  useEffect(() => {
    setLoading(true);
    currentAffiliate({
      callback: (data) => {
        if (data?.success) {
          if (data?.data.affiliate) {
            setLoading(false);
            setAffiliate(data?.data.affiliate);
          }
        }
      },
    });
  }, [currentAffiliate, reload]);

  const handleAmountSubmit = (e, { resetForm }) => {
    setUpdateloading(true);
    const callback = (res) => {
      setUpdateloading(false);
      if (res?.success) {
        resetForm();
        setReload(!reload);
        setIsUpdate(false);
      }
    };

    updateAffiliate({ id: affiliates?._id, data: e, callback });
  };

  const handleCopy = () => {
    setCopied(true);
    setSecondsLeft(10);
    successMessage("Link copied to clipboard!");
    navigator.clipboard.writeText(
      `https://amaniforged.com/r/${affiliate?.referralCode}`,
    );
    setTimeout(() => {
      setCopied(false);
    }, 10000);
  };

  return (
    <div>
      <div className='mx-auto p-6 bg-white shadow-lg rounded-2xl dark:bg-gray-800'>
        <MetaHead title={t("affiliate-link")} />
        {loading ? (
          <div className='flex rounded dark:bg-boxdark bg-white items-center justify-center min-h-96'>
            <BiLoaderAlt className='animate-spin text-4xl text-primary dark:text-white' />
          </div>
        ) : (
          <div className='mb-10 p-5 border border-gray-200 dark:border-gray-700 rounded-xl'>
            {isUpdate ? (
              <div>
                <Formik
                  initialValues={{
                    referralCode: affiliate?.referralCode,
                  }}
                  validationSchema={Yup.object({
                    referralCode: Yup.string().required(
                      "Referral Code  is required",
                    ),
                  })}
                  onSubmit={handleAmountSubmit}
                >
                  {({}) => (
                    <Form className='flex  flex-col space-y-4'>
                      <div className='mb-5.5'>
                        <p className='my-2 text-lg'>
                          <strong>Your Referral Code is:</strong>
                        </p>
                        <TextInput
                          // label={t("Minimum Withdraw Amount")}
                          id='referralCode'
                          rows={6}
                          name='referralCode'
                          placeholder='Enter Referral Code'
                          className='block w-full text-black dark:text-white rounded-md border px-3 py-2 dark:bg-black'
                        />
                      </div>

                      <div className='flex gap-3'>
                        <button
                          type='submit'
                          disabled={updateloading}
                          className='w-[100px] bg-red-600 text-white py-1 rounded-md col-span-2'
                        >
                          {updateloading ? (
                            <BiLoaderAlt className='m-auto animate-spin  text-white' />
                          ) : (
                            "Update"
                          )}
                        </button>

                        <button
                          type='button'
                          onClick={() => setIsUpdate(false)}
                          className='rounded-lg w-[100px] bg-gray-300 px-4 py-1  tracking-wide text-gray-800 hover:bg-gray-400'
                        >
                          Cancel
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            ) : (
              <div>
                <div className='mb-10'>
                  <p className='my-2 text-lg'>
                    <strong>Your Referral Code is:</strong>
                  </p>
                  <p className=' px-3 py-2'>#{affiliate?.referralCode}</p>
                </div>

                <div className='flex items-center gap-3'>
                  <button
                    onClick={() => setIsUpdate(true)}
                    className='w-[100px] bg-red-600 text-white py-1 rounded-md col-span-2'
                  >
                    Update
                  </button>

                  <button
                    onClick={() => handleCopy()}
                    disabled={copied}
                    title='Click to copy affiliate link'
                    className='block w-[100px]  rounded-md bg-green-600 disabled:bg-gray-600  py-1 text-white text-center'
                  >
                    {copied ? `Wait ${secondsLeft}s` : "Copy"}
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.app.visible,
});

export default connect(mapStateToProps, { updateAffiliate, currentAffiliate })(
  MyLinkPage,
);
